import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button, ListItemIcon, ListItemText, MenuItem, Popover, Typography } from '@mui/material';

import { selectUser, logoutUser } from 'app/store/userSlice';
import { ImageAvatar, useSettings, Icon } from 'app/main/components';

function UserMenu(props) {
	const dispatch = useDispatch<any>();
	const { t } = useSettings();
	const user = useSelector(selectUser);

	const [userMenu, setUserMenu] = useState(null);

	const userMenuClick = event => {
		setUserMenu(event.currentTarget);
	};

	const userMenuClose = () => {
		setUserMenu(null);
	};

	return (
		<>
			<Button className="min-h-40 min-w-40 px-0 py-0 md:px-16 md:py-6" onClick={userMenuClick}>
				<div className="mx-4 hidden flex-col items-end md:flex">
					<Typography component="span" className="flex font-semibold" color="primary.contrastText">
						{user.data.user_title}
					</Typography>
					<Typography className="text-11 font-medium capitalize" color="primary.contrastText">
						{user.data?.user_role_title ? user.data.user_role_title : 'Guest'}
					</Typography>
				</div>

				<div className="md:mx-4">
					<ImageAvatar
						dimensions={44}
						module="users"
						uid={user.data.user_uid}
						avatar={user.data.user_avatar}
						initials={user.data.user_title_initials}
					/>
				</div>
			</Button>

			<Popover
				open={Boolean(userMenu)}
				anchorEl={userMenu}
				onClose={userMenuClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'center'
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'center'
				}}
				classes={{
					paper: 'py-8'
				}}
			>
				{!user.roles || user.roles.length === 0 ? (
					<>
						<MenuItem component={Link} to="/login" role="button">
							<ListItemIcon className="min-w-40">
								<Icon icon="lock" />
							</ListItemIcon>
							<ListItemText primary="Login" />
						</MenuItem>
						{/* <MenuItem component={Link} to="/register" role="button">
							<ListItemIcon className="min-w-40">
								<Icon>person_add</Icon>
							</ListItemIcon>
							<ListItemText primary="Register" />
						</MenuItem> */}
					</>
				) : (
					<>
						<MenuItem
							component={Link}
							to={`/users/details/${user.data.user_uid}/summary`}
							onClick={userMenuClose}
							role="button"
						>
							<ListItemIcon className="min-w-40">
								<Icon icon="account-circle" />
							</ListItemIcon>
							<ListItemText primary={t('USER_MENU_PROFILE')} />
						</MenuItem>
						{/* <MenuItem component={Link} to="/apps/mail" onClick={userMenuClose} role="button">
							<ListItemIcon className="min-w-40">
								<Icon>mail</Icon>
							</ListItemIcon>
							<ListItemText primary="Inbox" />
						</MenuItem> */}
						<MenuItem
							onClick={() => {
								dispatch(logoutUser());
								userMenuClose();
							}}
						>
							<ListItemIcon className="min-w-40">
								<Icon icon="exit-to-app" />
							</ListItemIcon>
							<ListItemText primary={t('USER_MENU_LOGOUT')} />
						</MenuItem>
					</>
				)}
			</Popover>
		</>
	);
}

export default UserMenu;
